/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { AndroidFromJSONTyped, AndroidToJSON, } from './Android.js';
import { ChromeOsFromJSONTyped, ChromeOsToJSON, } from './ChromeOs.js';
import { IOsFromJSONTyped, IOsToJSON, } from './IOs.js';
import { LinuxFromJSONTyped, LinuxToJSON, } from './Linux.js';
import { MacOsFromJSONTyped, MacOsToJSON, } from './MacOs.js';
import { OtherOsFromJSONTyped, OtherOsToJSON, } from './OtherOs.js';
import { WindowsFromJSONTyped, WindowsToJSON, } from './Windows.js';
export function OperatingSystemFromJSON(json) {
    return OperatingSystemFromJSONTyped(json, false);
}
export function OperatingSystemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    switch (json['type']) {
        case 'android':
            return Object.assign(Object.assign({}, AndroidFromJSONTyped(json, true)), { type: 'android' });
        case 'chrome_os':
            return Object.assign(Object.assign({}, ChromeOsFromJSONTyped(json, true)), { type: 'chrome_os' });
        case 'i_os':
            return Object.assign(Object.assign({}, IOsFromJSONTyped(json, true)), { type: 'i_os' });
        case 'linux':
            return Object.assign(Object.assign({}, LinuxFromJSONTyped(json, true)), { type: 'linux' });
        case 'mac_os':
            return Object.assign(Object.assign({}, MacOsFromJSONTyped(json, true)), { type: 'mac_os' });
        case 'other_os':
            return Object.assign(Object.assign({}, OtherOsFromJSONTyped(json, true)), { type: 'other_os' });
        case 'windows':
            return Object.assign(Object.assign({}, WindowsFromJSONTyped(json, true)), { type: 'windows' });
        default:
            throw new Error(`No variant of OperatingSystem exists with 'type=${json['type']}'`);
    }
}
export function OperatingSystemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    switch (value['type']) {
        case 'android':
            return AndroidToJSON(value);
        case 'chrome_os':
            return ChromeOsToJSON(value);
        case 'i_os':
            return IOsToJSON(value);
        case 'linux':
            return LinuxToJSON(value);
        case 'mac_os':
            return MacOsToJSON(value);
        case 'other_os':
            return OtherOsToJSON(value);
        case 'windows':
            return WindowsToJSON(value);
        default:
            throw new Error(`No variant of OperatingSystem exists with 'type=${value['type']}'`);
    }
}
